import React, {Component, PropTypes} from 'react'
import OutsideScriptManager from '../OutsideScriptManager'

class SendTo extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    //all the import links are set from the config file
    this.affiliate = props.affiliate;

  }

  componentDidMount(){
    if(window.innerWidth > 996)
      OutsideScriptManager.load('sendTo')
  }


  render() { // REQUIRED
    return (
      <div className='gnm-send-to' style={{paddingLeft: '1px'}}>
        <div className="s2nPlayer-k9GwCzzY" ></div>
      </div>
    )
  }
}

export default SendTo



// WEBPACK FOOTER //
// ./app/components/custom/ssr/SendTo/index.js